import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsService, ContentSlotComponentData, CmsBannerCarouselComponent as model } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map, shareReplay, switchMap, take } from 'rxjs/operators';
import { SwiperOptions } from 'swiper/types';

/**
 * Копипаста коробочного класса, у которого все приватное.
 * и хуевое
 */
@Component({
  selector: 'sd-banner-carousel',
  templateUrl: 'banner-carousel.component.html',
  styleUrls: ['./banner-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdBannerCarouselComponent implements OnInit {
  defaultConfig: SwiperOptions = {
    slidesPerView: 1,
  };
  config: SwiperOptions;

  public componentData$: Observable<model>;
  public items$: Observable<ContentSlotComponentData[]>;

  constructor(
    protected componentData: CmsComponentData<model>,
    private cmsService: CmsService,
  ) {}

  ngOnInit(): void {
    this.componentData$ = this.componentData.data$.pipe(filter(Boolean));

    this.items$ = this.componentData$.pipe(
      // при переключении городов может так случится, что баннеров не будет. Это валидный кейс и  нужно нарисовать пустой слайдер,
      // а не слайдер с прошлым набором слотов
      map((data) => (data?.banners || '').trim()),
      distinctUntilChanged(),
      map((banners) => banners.split(' ')),
      // конвертируем массив стримов в массив слайдов
      switchMap((codes) =>
        combineLatest(codes.map((code: string) => this.cmsService.getComponentData(code).pipe(take(1)))),
      ),
      // убираем те, что проебались на рестрикшенах
      map((slideList) => slideList.filter((slide) => slide !== null)),
      shareReplay({ bufferSize: 1, refCount: true }),
    );
  }
}
